module.exports = __webpack_public_path__ + "static/media/ws01.0a016d3b.webp";